<template>
  <div :style="{direction:$t('direction')}" class="site-wrapper">

    <Header></Header>
    
    <div class="aboutus-wrapper">
        <div class="aboutus-inner" v-html="state_setting.rules_text">
            
        </div>
    </div>

    <Footer></Footer>
    

  </div>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
export default {
  name: 'AboutUs',
  components:{
    Header,
    Footer
  },
  data : () => ({
    
  }),
  watch:{
    
  },
  mounted() {
    this.activeLoading(false)
  }
}
</script>
<style scoped>
.spacer-about{
    height: 100px;
    width: 100%;
}
.aboutus-wrapper{
    padding: 40px 70px;
}
.aboutus-wrapper .aboutus-inner{
    padding: 40px;
    border-radius: 20px;
    background: var(--theme2);
    color: #fff !important;
}
</style>